import { render, staticRenderFns } from "./organizationDetails.vue?vue&type=template&id=c89df336&scoped=true&"
import script from "./organizationDetails.vue?vue&type=script&lang=js&"
export * from "./organizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./organizationDetails.vue?vue&type=style&index=0&id=c89df336&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89df336",
  null
  
)

export default component.exports